export default "__VITE_ASSET__hVDNfBYc__"